import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import { isDeliveryMeasureEnabledForChannel } from 'cio/utils/metrics/measure';
import AnalysisController from './controller';

export default class Analysis extends Route {
  crumb() {
    return {
      name: 'Analysis',
      path: 'analysis',
    };
  }

  setupController(controller: AnalysisController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.deserializeQueryParams();
    controller.setAllAvailableChannels();

    if (
      !isDeliveryMeasureEnabledForChannel('opened', 'email') &&
      controller.chartMeasure === 'delivery_metrics.opened'
    ) {
      controller.set('chartMeasure', 'delivery_metrics.clicked');
    }
  }

  resetController(controller: AnalysisController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.resetQueryParams();
    }
  }
}
